module.exports = __webpack_public_path__ + "img/material.1c1ad564.jpg";